import DOMPurify from "dompurify"
import React from "react"

import BackgroundImage from "./BackgroundImage"
import SideCheckBox from "./SideCheckBox"
import SideRemoveButton from "./SideRemoveButton"
import TagItem from "./tags/TagItem"
import Tags from "./tags/Tags"

const CommunityListItem = ({
    id,
    name,
    description,
    image_url,
    activeId,
    member_count_string,
    system_labels,
    onClick,
    onRemove,
    onChecked,
    isAdded
}) => (
    <div
        className={`list-group-item ${id === activeId ? "active" : ""}`}
        onClick={onClick || onChecked ? (onClick || onChecked)(id) : () => null}
    >
        <BackgroundImage
            classList={["list-group-item-thumb"]}
            imageUrl={image_url}
            isThumbnail={true}
        />
        <div className="list-group-item-content">
            <h4>{name}</h4>
            {description && (
                <p
                    className="text-shorten-single-line"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(description, {
                            ALLOWED_TAGS: []
                        })
                    }}
                />
            )}
            {member_count_string && <p>{member_count_string}</p>}
            <Tags style={{ marginTop: "10px" }}>
                {system_labels &&
                    system_labels.map(label => (
                        <TagItem key={label} isGrey={true}>
                            {label}
                        </TagItem>
                    ))}
            </Tags>
            {onRemove && <SideRemoveButton onClick={onRemove} />}
            {onChecked && <SideCheckBox isAdded={isAdded} />}
        </div>
    </div>
)

export default CommunityListItem
